<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-01-15 20:49:51
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-12-29 20:27:01
-->
<template>
  <div class="content">
    <div class="map-wrap">
      <div class="initial-btn" @click="initialAddress">
        <i class="iconfont icon-chushidingwei"></i>
      </div>
      <div class="map-div" id="mapDiv" ref="mapDiv"></div>
    </div>
  </div>
</template>

<script>
import TalksMap from "@/utils/initMapTalks.js";
export default {
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      mapHasHover: true,
      mapHasSelected: false,
      coordinate: [116.177427669, 28.861500052],
    };
  },
  props: {
    landList: {
      type: Array,
    },
  },
  mounted() {
    this.TalksMapDialog.sendThis(this);
    this.getMapInit();
    if (this.landList && this.landList.length > 0) {
      let lng, lat;
      let temp = JSON.parse(this.landList[0].centroid).coordinates;
      lng = temp[0];
      lat = temp[1];
      let Coordinate = {
        x: lng,
        y: lat,
      };
      this.coordinate = Coordinate;
      this.TalksMapDialog.land(
        this.landList,
        "croplandEdge",
        "",
        this.mapHasHover,
        this.mapHasSelected
      );
    }
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.content {
  .map-wrap {
    position: relative;
    height: 570px;
    .initial-btn {
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 1;
      cursor: pointer;
      width: 40px;
      height: 40px;
      background: #ffffff;
      border-radius: 5px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        color: #018388;
        font-size: 24px;
      }
    }
    .map-div {
      height: 100%;
    }
  }
}
</style>
